import React, { useState, useEffect, } from 'react';
import { ModalOptionForm } from '../molecules/modalOptionForm';
import { PullDownOptionForm } from '../molecules/pullDownOptionForm';
import { connect } from 'react-redux';
import { Button } from '../atoms/button';
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import { golfFacility } from "../../const";
import common from "../../resources/js/common/common";

const SoloVacancyInfoContainer = (props) => {
    const {
        playDate1,
        soloCourse,
        setSoloCourse,
        soloKaiinken,
        setSoloKaiinken,
        onClickPlay,
        runGetVacancyList,
        setGolfSoloSearchData,
    } = props;

    const { getHoliday } = GetPublicHoliday();

    const [NotSearch, setNotSearch] = useState(false);

    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");

    // 検索ボタン押下時
    const onClickSearch = () => {
        const playDate = new Date(playDate1);
        // 検索基準の日付を設定
        const nextDate = new Date(playDate.getFullYear(), playDate.getMonth(), playDate.getDate());

        let y = nextDate.getFullYear();
        let m = nextDate.getMonth() + 1;
        let d = nextDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        //選択された会員権から施設コードを詰め込む
        let useMemberShipAuth;
        let reqContractNo = "";
        let reqGolfCourseId = "";
        let reqGolfCourseName = "";
        let kaiinKind;
        soloKaiinken.forEach((data) => {
            if (data.selected === true) {
                kaiinKind = data.kaiinkenSyubetCd;
                reqContractNo = data.contractNo;
                soloCourse.forEach((courseData) => {
                    if (courseData.id === data.facilityCd) {
                        reqGolfCourseId = courseData.facilityCd
                        reqGolfCourseName = courseData.value
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });
        // リクエスト情報の格納
        let newGolfSoloSearchData = {
            playDate: `${y}-${m}-${d}`,
            golfCourseId: reqGolfCourseId,
            golfCourseName: reqGolfCourseName,
            memberShipAuth: useMemberShipAuth,
            kaiinKind:kaiinKind,
            contractNo: reqContractNo
        }
        setGolfSoloSearchData(newGolfSoloSearchData);

        const req = {
            playDate: `${y}-${m}-${d}`,
            golfCourseId: reqGolfCourseId,
            membershipAuthID: useMemberShipAuth,
            searchType: 0,
            kaiinKind:kaiinKind
        }
        runGetVacancyList(req);
    }

    // プレー日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(playDate1);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();

        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    const onChangeKaiinkenName = (e) => {
        setKaiinkenNumber(e.target.value);
        soloKaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
                common.doPost(golfFacility, { kaiinKind: data.kaiinkenSyubetCd, sisetuCd: data.sisetuCd }, afterGetFacility);
            } else {
                data.selected = false;
            }
        })
        setSoloKaiinken(soloKaiinken);
    }

    // 施設取得後処理
    const afterGetFacility = (res) => {
        const data = res.data.map((item) => {
            return {
                id: item.courseid,
                facilityCd: item.facility_cd,
                value: item.facility_name,
                category: item.hotel_category_name,
                class: "area_course",
                checked: true,
                zip: item.zip,
                address: item.address,
                access_car: item.access_car,
                facility_overview_title: item.facility_overview_title,
                facility_overview_detail: item.facility_overview_detail,
                url: item.url,
                image_path: item.image_path,
                memberShipAuth: item.memberShipAuth,
                sortNum: parseInt(item.inside_category_sort),
            };
        });
        //表示施設のソート処理
        data.sort(function (first, second) {
            if (first.sortNum > second.sortNum) {
                return 1;
            } else if (first.sortNum < second.sortNum) {
                return -1;
            } else {
                return 0;
            }
        })

        setSoloCourse(data);
    }


    return (
        <div className='soloSearch_container'>
            <div className={NotSearch ? "soloSearchErrorMessage" : "hiddenItem"} > 検索に失敗しました</div>
            <div className='soloSearch_conditionsWrapper'>
                <ModalOptionForm
                    id={"playDate1"}
                    divClass="soloSearch_wrap"
                    title={"プレー日"}
                    onClick={onClickPlay}
                    text={getDateToString()}
                />
                <PullDownOptionForm
                    divClass="soloSearch_wrap"
                    title={"会員権選択"}
                    selectClass={"pullDownOptionKaiinkenStyle"}
                    data={soloKaiinken}
                    state={kaiinkenNumber}
                    onChange={onChangeKaiinkenName}
                />
            </div>
            <Button buttonText="検 索" className="soloSearch_searchBtn" onClick={onClickSearch} />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        group: state.group,
        startTime: state.startTime,
        soloCourse: state.soloCourse,
        soloKaiinken: state.soloKaiinken,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSoloCourse: (item) => {
            dispatch({ type: "SOLO_COURSE", payload: { soloCourse: item } })
        },
        setSoloKaiinken: (item) => {
            dispatch({ type: "SOLO_KAIINKEN", payload: { soloKaiinken: item } })
        },
        setGolfSoloSearchData: (item) => {
            dispatch({ type: "GOLF_SOLO_SEARCH_DATA", payload: { golfSoloSearchData: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SoloVacancyInfoContainer);